// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1kYgV","item":"PaymentsMobile_item__3LOcx","label":"PaymentsMobile_label__1T93q","amount":"PaymentsMobile_amount__35dcj"};